// extracted by mini-css-extract-plugin
module.exports = {"boxTitle":"Person_boxTitle__ntHZI","root":"Person_root__aV1tQ","fields":"Person_fields__3x1iu","expandButton":"Person_expandButton__kCih4"};